"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", "% !important;\n  float: left;\n  padding: 0 15px;\n  box-sizing: border-box;\n  margin-left: ", "% !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// TODO remove temp col
var ColTemp = (0, _uiKit.styled)('div')(_templateObject(), function (_ref) {
  var col = _ref.col;
  return col ? 100 / 12 * col : 100;
}, function (_ref2) {
  var offset = _ref2.offset;
  return offset ? 100 / 12 * offset : 0;
}); // TODO replace with styled-bootstrap component

var ColUi = function ColUi(_ref3) {
  var col = _ref3.col,
      offset = _ref3.offset,
      children = _ref3.children,
      containerProps = _ref3.containerProps;
  return /*#__PURE__*/_react.default.createElement(ColTemp, _objectSpread({
    col: col,
    offset: offset,
    children: children
  }, containerProps));
};

var _default = ColUi;
exports.default = _default;